// Cancelling your own leave — owner decision 2026-10.
//
//   pending                     → you may WITHDRAW it
//   approved, not started yet   → you may CANCEL it (to change dates: cancel,
//                                 then request again — approved leave is
//                                 never edited)
//   approved, already started   → only your manager or HR can cancel it
//
// Always with a reason. The server (leave-service /cancel) is the authority —
// "today" there is the employee's own calendar day; this mirrors it so the
// button only shows when it will work, and the server's refusal is toasted
// verbatim when the two disagree around midnight.

export type LeaveCancelAction = 'withdraw' | 'cancel' | 'ask_manager' | null;

/** Local calendar date as YYYY-MM-DD (never toISOString — that is UTC). */
export const localTodayIso = (d: Date = new Date()): string => {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

/** `ask_manager` only while the leave is still running — finished leave
 *  needs no hint on every old row. */
export function leaveCancelAction(
  status: string,
  startDate: string | undefined,
  todayIso: string = localTodayIso(),
  endDate?: string,
): LeaveCancelAction {
  const s = (status || '').toLowerCase();
  if (s === 'pending') return 'withdraw';
  if (s !== 'approved' || !startDate) return null;
  if (startDate.slice(0, 10) > todayIso) return 'cancel';
  const end = (endDate || startDate).slice(0, 10);
  return end >= todayIso ? 'ask_manager' : null;
}

/** "Cancelled — Plans changed" for a cancelled row; the bare status otherwise. */
export function leaveStatusLabel(status: string, cancellationReason?: string | null): string {
  const s = (status || '').toLowerCase();
  const label = s ? s[0].toUpperCase() + s.slice(1) : '';
  const reason = (cancellationReason || '').trim();
  return s === 'cancelled' && reason ? `${label} — ${reason}` : label;
}
